export default {"src":"/_next/static/media/db.a0f9dc2d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};